// extracted by mini-css-extract-plugin
export default {"footer":"mAZF70It--Footer_footer__PxxIj","logo":"mAZF70It--Footer_logo__w79hm","legalLinks":"mAZF70It--Footer_legalLinks__RbOzh"};